export default '/build/658934e7.jpg'